import updateMessageLikers from '../actions/updateMessageLikers';
import likeItemService from '../services/likeItemService';
import { ClientItemId } from 'owa-client-ids';
import { TableView } from 'owa-mail-list-store';
import { lazySetTriageActionAnnouncement } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import loc from 'owa-localize';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { orchestrator, action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { userMailInteractionAction } from 'owa-mail-actions';
import { messageLikedAnnouncement, messageUnlikedAnnouncement } from './likeItem.locstring.json';

const likeItem = action(
    'likeItem',
    (
        itemId: ClientItemId,
        message: Message,
        tableView: TableView,
        isLocalUpdateOnly: boolean,
        instrumentationContext: InstrumentationContext
    ) =>
        addDatapointConfig(
            {
                name: 'LikeItem',
                actionSource: 'ReadingPane',
            },
            {
                itemId,
                message,
                tableView,
                isLocalUpdateOnly,
                instrumentationContext,
            }
        )
);

orchestrator(likeItem, actionMessage => {
    const { tableView, itemId, message, instrumentationContext } = actionMessage;
    const userEmailAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
    const isUnlike = message.Likers
        ? message.Likers.some(email => email.EmailAddress === userEmailAddress)
        : false;
    updateMessageLikers(
        message,
        tableView,
        isUnlike,
        userEmailAddress,
        getUserConfiguration().SessionSettings.UserDisplayName
    );
    if (!actionMessage.isLocalUpdateOnly) {
        likeItemService(itemId, isUnlike, itemId.mailboxInfo.requestOptions);
    }

    if (!isUnlike) {
        userMailInteractionAction('Like', [instrumentationContext], {
            itemIds: [message.ItemId.Id],
            conversationIds: [message.ConversationId.Id],
        });
    }

    lazySetTriageActionAnnouncement.importAndExecute(
        isUnlike ? loc(messageUnlikedAnnouncement) : loc(messageLikedAnnouncement)
    );
});

export default likeItem;
